import { render, staticRenderFns } from "./CollaboratorDelivery.vue?vue&type=template&id=0d7f0998"
import script from "./CollaboratorDelivery.vue?vue&type=script&lang=js"
export * from "./CollaboratorDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports